import { MyCourseLessonList } from "./MyCourseLessonList";

export function MyCourseClasses() {
	return (
		<div className="my-course-basic-info-container">
			<MyCourseLessonList />
		</div>
	);
}
